/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {
  AfterContentInit,
  Component,
  ContentChild,
  ContentChildren,
  Directive,
  ElementRef,
  Optional,
  QueryList,
  Renderer2,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import {MATERIAL_COMPATIBILITY_MODE, MdLine, MdLineSetter} from '@angular/material/core';
import {CanDisableRipple, mixinDisableRipple} from '@angular/material/core';
/**
 * \@docs-private
 */
export class MdListBase {}
export const /** @type {?} */ _MdListMixinBase = mixinDisableRipple(MdListBase);
/**
 * \@docs-private
 */
export class MdListItemBase {}
export const /** @type {?} */ _MdListItemMixinBase = mixinDisableRipple(MdListItemBase);
/**
 * Divider between items within a list.
 */
export class MdListDivider {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'md-divider, mat-divider',
  host: {
    'role': 'separator',
    'aria-orientation': 'horizontal'
  }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdListDivider_tsickle_Closure_declarations() {
/** @type {?} */
MdListDivider.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdListDivider.ctorParameters;
}

/**
 * A Material Design list component.
 */
export class MdList extends _MdListMixinBase implements CanDisableRipple {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'md-list, mat-list, md-nav-list, mat-nav-list',
  host: {'role': 'list'},
  template: '<ng-content></ng-content>',
  styleUrls: ['list.css'],
  inputs: ['disableRipple'],
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdList_tsickle_Closure_declarations() {
/** @type {?} */
MdList.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdList.ctorParameters;
}

/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
export class MdListCssMatStyler {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'md-list, mat-list',
  host: {'class': 'mat-list'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdListCssMatStyler_tsickle_Closure_declarations() {
/** @type {?} */
MdListCssMatStyler.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdListCssMatStyler.ctorParameters;
}

/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
export class MdNavListCssMatStyler {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'md-nav-list, mat-nav-list',
  host: {'class': 'mat-nav-list'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdNavListCssMatStyler_tsickle_Closure_declarations() {
/** @type {?} */
MdNavListCssMatStyler.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdNavListCssMatStyler.ctorParameters;
}

/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
export class MdDividerCssMatStyler {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'md-divider, mat-divider',
  host: {'class': 'mat-divider'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdDividerCssMatStyler_tsickle_Closure_declarations() {
/** @type {?} */
MdDividerCssMatStyler.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdDividerCssMatStyler.ctorParameters;
}

/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
export class MdListAvatarCssMatStyler {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[md-list-avatar], [mat-list-avatar], [mdListAvatar], [matListAvatar]',
  host: {'class': 'mat-list-avatar'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdListAvatarCssMatStyler_tsickle_Closure_declarations() {
/** @type {?} */
MdListAvatarCssMatStyler.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdListAvatarCssMatStyler.ctorParameters;
}

/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
export class MdListIconCssMatStyler {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[md-list-icon], [mat-list-icon], [mdListIcon], [matListIcon]',
  host: {'class': 'mat-list-icon'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdListIconCssMatStyler_tsickle_Closure_declarations() {
/** @type {?} */
MdListIconCssMatStyler.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdListIconCssMatStyler.ctorParameters;
}

/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
export class MdListSubheaderCssMatStyler {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[md-subheader], [mat-subheader], [mdSubheader], [matSubheader]',
  host: {'class': 'mat-subheader'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdListSubheaderCssMatStyler_tsickle_Closure_declarations() {
/** @type {?} */
MdListSubheaderCssMatStyler.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdListSubheaderCssMatStyler.ctorParameters;
}

/**
 * An item within a Material Design list.
 */
export class MdListItem extends _MdListItemMixinBase implements AfterContentInit, CanDisableRipple {
private _lineSetter: MdLineSetter;
private _isNavList: boolean = false;

   _lines: QueryList<MdLine>;
/**
 * @param {?} avatar
 * @return {?}
 */
set _hasAvatar(avatar: MdListAvatarCssMatStyler) {
    if (avatar != null) {
      this._renderer.addClass(this._element.nativeElement, 'mat-list-item-avatar');
    } else {
      this._renderer.removeClass(this._element.nativeElement, 'mat-list-item-avatar');
    }
  }
/**
 * @param {?} _renderer
 * @param {?} _element
 * @param {?} _list
 * @param {?} navList
 */
constructor(private _renderer: Renderer2,
private _element: ElementRef,
private _list: MdList,
               navList: MdNavListCssMatStyler) {
    super();
    this._isNavList = !!navList;
  }
/**
 * @return {?}
 */
ngAfterContentInit() {
    this._lineSetter = new MdLineSetter(this._lines, this._renderer, this._element);
  }
/**
 * Whether this list item should show a ripple effect when clicked.
 * @return {?}
 */
_isRippleDisabled() {
    return !this._isNavList || this.disableRipple || this._list.disableRipple;
  }
/**
 * @return {?}
 */
_handleFocus() {
    this._renderer.addClass(this._element.nativeElement, 'mat-list-item-focus');
  }
/**
 * @return {?}
 */
_handleBlur() {
    this._renderer.removeClass(this._element.nativeElement, 'mat-list-item-focus');
  }
/**
 * Retrieves the DOM element of the component host.
 * @return {?}
 */
_getHostElement(): HTMLElement {
    return this._element.nativeElement;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'md-list-item, mat-list-item, a[md-list-item], a[mat-list-item]',
  host: {
    'role': 'listitem',
    'class': 'mat-list-item',
    '(focus)': '_handleFocus()',
    '(blur)': '_handleBlur()',
  },
  inputs: ['disableRipple'],
  templateUrl: 'list-item.html',
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [{provide: MATERIAL_COMPATIBILITY_MODE, useValue: true}],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: ElementRef, },
{type: MdList, decorators: [{ type: Optional }, ]},
{type: MdNavListCssMatStyler, decorators: [{ type: Optional }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'_lines': [{ type: ContentChildren, args: [MdLine, ] },],
'_hasAvatar': [{ type: ContentChild, args: [MdListAvatarCssMatStyler, ] },],
};
}

function MdListItem_tsickle_Closure_declarations() {
/** @type {?} */
MdListItem.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdListItem.ctorParameters;
/** @type {?} */
MdListItem.propDecorators;
/** @type {?} */
MdListItem.prototype._lineSetter;
/** @type {?} */
MdListItem.prototype._isNavList;
/** @type {?} */
MdListItem.prototype._lines;
/** @type {?} */
MdListItem.prototype._renderer;
/** @type {?} */
MdListItem.prototype._element;
/** @type {?} */
MdListItem.prototype._list;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
